import React from "react";

import "./vcEditVaccineView.scss";
import FormInputWithHeader from "../../../../common/FormInputWithHeader";
import DatePickerInputField from "../../../common/DatePickerInputField";
import VitalComponent from "../../../../common/VitalComponent";

const VCEditVaccineView = (props) => {
  const {
    editedVaccineDetails,
    isCustomValue,
    vaccineBrands,
    handleVaccineBrand,
    handleVaccineBrandInput,
    handleDueDateChange,
    handleVaccineDateChange,
    handleVitalsChange,
    handleUpArrowClick,
    handleDownArrowClick,
  } = props;

  // Display UI ===>

  const displayEditVaccineContent = () => {
    return (
      <div className="edit-vaccine-content">
        <div className="evc-select">
          <FormInputWithHeader
            title=""
            inputType="dropdown"
            placeholder="Vaccine Brand"
            value={editedVaccineDetails?.vaccine_brand_name}
            options={vaccineBrands}
            isCustomValue={isCustomValue}
            handleOnChangeInput={handleVaccineBrand}
            handleOnChangeDropdownInput={handleVaccineBrandInput}
          />
        </div>
        <div className="evc-date-picker-container">
          <div className="evc-date-picker evc-due-date">
            <DatePickerInputField
              placeholder="Due Date"
              value={editedVaccineDetails?.scheduled_date}
              handleDateChange={handleDueDateChange}
            />
          </div>
          <div className="evc-date-picker evc-vaccinated-date">
            <DatePickerInputField
              placeholder="Vaccinated Date"
              value={editedVaccineDetails?.vaccinated_date}
              handleDateChange={handleVaccineDateChange}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          {editedVaccineDetails?.vitals_list?.map((item, ind) => (
            <div className="evc-vitals" key={ind}>
              <VitalComponent
                item={item}
                placeholder={item.name}
                value={item.value}
                selectedUnit={item.unit}
                unitList={item.unitList}
                allowDecimal={true}
                handleOnChange={handleVitalsChange}
                handleUpArrowClick={handleUpArrowClick}
                handleDownArrowClick={handleDownArrowClick}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  // <===

  return (
    <div className="vc-edit-vaccine-view">{displayEditVaccineContent()}</div>
  );
};

export default VCEditVaccineView;
